export { default } from '@material-ui/core/Grid';

export type GridProps = import('@material-ui/core/Grid').GridProps;
export type GridSize = import('@material-ui/core/Grid').GridSize;
export type GridSpacing = import('@material-ui/core/Grid').GridSpacing;
